import { Flex, Grid } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterBuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;

  [data-testid="filter-builder-photoalbum"] {
    [data-testid="start-date-field"], [data-testid="end-date-field"] {
      height: 30px;
      width: 232px;
      outline: none;
    }
    .datapicker-footer button {
      font-weight: 600;
    }
  }

  .field-content {

    [data-testid="start-date-field"],
    [data-testid="end-date-field"],
    [data-testid="driver-field-input-search"] {
      & + .oneface-icon-button {
        height: 28px;
        width: 30px;
        border-radius: 0 1px 1px 0;
        padding: 0 !important;
      }
    }

    input[data-testid*="time-"],input[data-testid*="time-"] {
      height: 30px;
      width: 100%;
    }
    [data-testid="driver-field-icon-search"] {
      font-size: 16px;
    }
    [data-testid="selected-data"] {
      top: 151px !important;
      margin-top: -1px !important;

      [data-testid*="remove-item"] {
        height: auto !important;
      }
      .remove-all {
        border-radius: 0;
        padding: 0;
      }
    }
    .rdp-day,button[data-testid*="input_"] {
      padding-inline: 0;
    }
    .datapicker-footer button {
      padding: 6px 16px !important;
    }
    [data-testid="input_increment_btn"], [data-testid="input_decrement_btn"] {
      padding-inline: 6px !important;

      &:disabled {
        border: none;
      }
    }
    [data-testid="time-period"][readonly] {
      background: #fff;
      cursor: auto;
    }
  }
  .oneface-icon-button {
    height: 20px;
    width: 20px;
  }

  .buttons-list button {
    padding: 0.375rem 1rem !important;
  }
`;

export const GridContainer = styled(Flex)`
  margin-top: 8.2rem;
  height: calc(100% - 130px);

  .selection-container div:first-child button {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    padding: 0;
  }
`;

export const GridContent = styled(Grid)`
  --card-size: 13.125rem;

  padding: 1.25rem;
  overflow-y: scroll;
`;

export const FlexContainer = styled(Flex)`
  flex: 1;

  &.col-span-all {
    grid-column: 1 / -1;
  }

  &.noData {
    width: 100%;
    height: calc(100% - 120px);

    .empty-state {
      height: 100%;
      width: 100%;
    }
  }
`;

export const FlexContainerLoading = styled(Flex)`
  grid-column: 1 / -1;
`;
